// Group GROUP 16. Reported Speech and Perspective
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group16Data = {
  "id": "group_16",
  "title": {
    "tc": "間接引語與視角",
    "sc": "间接引语与视角",
    "en": "Reported Speech and Perspective"
  },
  "subtitle": {
    "tc": "Reported Speech and Perspective",
    "sc": "Reported Speech and Perspective",
    "en": "Reported Speech and Perspective"
  },
  "icon": "💬",
  "difficulty": "intermediate",
  "color": "from-orange-500 to-orange-600",
  "topics": [
    {
      "id": "backshift",
      "title": {
        "tc": "時態回溯",
        "sc": "时态回溯",
        "en": "Backshift (Past Reporting)"
      },
      "description": {
        "tc": "學習過去報導動詞的時態回溯",
        "sc": "学习过去报道动词的时态回溯",
        "en": "Learn backshift with past reporting verbs"
      },
      "icon": "⏪",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "backshift_1",
          "sentence": "He said that he was tired.",
          "analysis": "He (S) said (V) <that> [he (S) was (V) tired (C)].",
          "translation": {
            "tc": "他說他累了。",
            "sc": "他说他累了。",
            "en": "He said that he was tired."
          }
        },
        {
          "id": "backshift_2",
          "sentence": "She explained that she had lost it.",
          "analysis": "She (S) explained (V) <that> [she (S) had lost (V) it (O)].",
          "translation": {
            "tc": "她解釋說她把它弄丟了。",
            "sc": "她解释说她把它弄丢了。",
            "en": "She explained that she had lost it."
          }
        },
        {
          "id": "backshift_3",
          "sentence": "They claimed that prices would fall.",
          "analysis": "They (S) claimed (V) <that> [prices (S) would fall (V)].",
          "translation": {
            "tc": "他們聲稱價格會下跌。",
            "sc": "他们声称价格会下跌。",
            "en": "They claimed that prices would fall."
          }
        },
        {
          "id": "backshift_4",
          "sentence": "I thought that it was raining.",
          "analysis": "I (S) thought (V) <that> [it (S) was raining (V)].",
          "translation": {
            "tc": "我以為在下雨。",
            "sc": "我以为在下雨。",
            "en": "I thought that it was raining."
          }
        },
        {
          "id": "backshift_5",
          "sentence": "We believed that he was honest.",
          "analysis": "We (S) believed (V) <that> [he (S) was (V) honest (C)].",
          "translation": {
            "tc": "我們相信他是誠實的。",
            "sc": "我们相信他是诚实的。",
            "en": "We believed that he was honest."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：過去報導動詞 → 從句時態多回溯；事實恆真可不回溯。",
        "sc": "要点：过去报道动词 → 从句时态多回溯；事实恒真可不回溯。",
        "en": "Key points: past reporting verbs → clause tenses often backshift; universal truths may not backshift."
      }
    }
  ]
};
